import React from 'react'
import HomeBanner from '../Components/homesection/HomeBanner'

function Home() {
  return (
    <>
    <HomeBanner />
    </>
  )
}

export default Home